/* ============================================================
   Llorrea — galerij, Trust Bear, garantieblok, sterren, accordeon
   ============================================================ */
(function(){

  /* ---------- 1. Grote foto: vegen, slepen, scrollen ---------- */
  function gallery(root){
    if(root.dataset.lloSwipe === '1') return;
    root.dataset.lloSwipe = '1';

    var hero  = root.querySelector('.llo__heroMedia');
    var strip = root.querySelector('.llo__thumbs');
    if(!hero || !strip) return;

    function thumbs(){ return Array.prototype.slice.call(strip.querySelectorAll('[data-llo-thumb]')); }
    function count(){
      var all = thumbs();
      var uniq = all.filter(function(t){ return !t.hasAttribute('data-llo-clone'); });
      return uniq.length || all.length;
    }
    function activeIndex(){
      var all = thumbs(), n = count() || 1;
      for(var i = 0; i < all.length; i++){ if(all[i].classList.contains('is-active')) return i % n; }
      return 0;
    }
    function go(step){
      var n = count();
      if(n < 2) return;
      var all = thumbs();
      var next = (activeIndex() + step + n) % n;
      if(all[next]) all[next].click();
    }

    var x0 = null, y0 = null, moved = false;
    hero.addEventListener('touchstart', function(e){
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; moved = false;
    }, { passive: true });
    hero.addEventListener('touchmove', function(e){
      if(x0 === null) return;
      var t = e.changedTouches[0];
      if(Math.abs(t.clientX - x0) > 10 && Math.abs(t.clientX - x0) > Math.abs(t.clientY - y0)) moved = true;
    }, { passive: true });
    hero.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(moved && Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      x0 = null; y0 = null;
    }, { passive: true });

    var mx = null, dragging = false;
    hero.addEventListener('mousedown', function(e){ mx = e.clientX; dragging = false; hero.classList.add('is-dragging'); });
    window.addEventListener('mousemove', function(e){ if(mx !== null && Math.abs(e.clientX - mx) > 12) dragging = true; });
    window.addEventListener('mouseup', function(e){
      if(mx === null) return;
      var dx = e.clientX - mx;
      hero.classList.remove('is-dragging');
      if(dragging && Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
      mx = null; dragging = false;
    });
    hero.addEventListener('dragstart', function(e){ e.preventDefault(); });

    var lock = false;
    hero.addEventListener('wheel', function(e){
      var dx = e.deltaX, dy = e.deltaY;
      var amount = Math.abs(dx) > Math.abs(dy) ? dx : (e.shiftKey ? dy : 0);
      if(!amount || Math.abs(amount) < 12) return;
      e.preventDefault();
      if(lock) return;
      lock = true;
      go(amount > 0 ? 1 : -1);
      setTimeout(function(){ lock = false; }, 320);
    }, { passive: false });

    hero.setAttribute('tabindex', '0');
    hero.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight') go(1);
      if(e.key === 'ArrowLeft') go(-1);
    });

    var all = thumbs();
    if(all.length && !strip.querySelector('.is-active')) all[0].classList.add('is-active');
  }

  /* ---------- 2. Trust Bear onder de bestelknop ---------- */
  var TRUST = '[class*="trust" i],[id*="trust" i],[class*="bear" i],[id*="bear" i],[class*="tb-" i],[class*="payment" i],[class*="badge" i]';

  function moveTrust(root){
    var atc = root.querySelector('.llo__atc');
    var anchor = atc ? (atc.closest('form') || atc) : null;
    if(!anchor || !anchor.parentNode) return;
    Array.prototype.slice.call(root.querySelectorAll('.llo__app')).forEach(function(app){
      if(app.dataset.lloMoved === '1') return;
      if(!app.querySelector(TRUST)) return;
      if(app.compareDocumentPosition(anchor) & Node.DOCUMENT_POSITION_FOLLOWING){
        app.dataset.lloMoved = '1';
        anchor.parentNode.insertBefore(app, anchor.nextSibling);
      }
    });
  }

  /* ---------- 3. Garantieblok onder de schaarstebalk ---------- */
  function moveGuarantee(root){
    var gar = root.querySelector('.llo__gar');
    if(!gar || gar.dataset.lloMoved === '1') return;
    var after = root.querySelector('.llo__scar') || root.querySelector('.llo__pay');
    if(!after || !after.parentNode) return;
    gar.dataset.lloMoved = '1';
    after.parentNode.insertBefore(gar, after.nextSibling);
  }

  /* ---------- 4. Sterren als blokjes ---------- */
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.6 2.9 6 6.6.9-4.8 4.6 1.2 6.5-5.9-3.2-5.9 3.2 1.2-6.5L2.5 9.5l6.6-.9 2.9-6Z"/></svg>';

  function stars(root){
    var wrap = root.querySelector('.llo__revStars');
    if(!wrap || wrap.dataset.lloBoxes === '1') return;

    var label = wrap.getAttribute('aria-label') || '';
    var rating = parseFloat(String(label).replace(',', '.'));
    if(isNaN(rating)) rating = 5;

    wrap.dataset.lloBoxes = '1';
    wrap.classList.add('llo__revStars--boxes');
    wrap.innerHTML = '';

    for(var i = 1; i <= 5; i++){
      var box = document.createElement('span');
      box.className = 'llo__starBox';
      if(rating >= i){
        /* gevuld */
      } else if(rating > i - 1){
        box.className += ' llo__starBox--half';
      } else {
        box.className += ' llo__starBox--off';
      }
      box.innerHTML = STAR;
      wrap.appendChild(box);
    }
  }

  /* ---------- 5. Uitklapblokken: er staat er maar een open ---------- */
  function accordion(root){
    var wrap = root.querySelector('.llo__expandWrap');
    if(!wrap || wrap.dataset.lloAcc === '1') return;
    wrap.dataset.lloAcc = '1';

    var items = Array.prototype.slice.call(wrap.querySelectorAll('details.llo__exp'));
    if(items.length < 2) return;

    /* staan er meerdere open bij het laden, laat dan alleen de eerste open */
    var opened = items.filter(function(d){ return d.open; });
    opened.slice(1).forEach(function(d){ d.open = false; });

    items.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(!d.open) return;
        items.forEach(function(o){ if(o !== d && o.open) o.open = false; });
      });
    });
  }

  function boot(){
    document.querySelectorAll('[data-llo]').forEach(function(root){
      gallery(root);
      stars(root);
      accordion(root);
      moveTrust(root);
      moveGuarantee(root);
      var tries = 0;
      var iv = setInterval(function(){
        moveTrust(root);
        moveGuarantee(root);
        if(++tries > 10) clearInterval(iv);
      }, 500);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
})();
